//export const URL="https://60fdsy8ai9.execute-api.us-east-1.amazonaws.com/dev"
export const IMGURL="https://mobimart.s3.ap-south-1.amazonaws.com/"
export const URL="https://60fdsy8ai9.execute-api.us-east-1.amazonaws.com/dev"
//export const URL="http://localhost:3000/dev"
export const BUCKET_NAME="mobimart-images"
export const WSURL="wss://h0stl738lj.execute-api.us-east-1.amazonaws.com/dev"
//export const WSURL="ws://localhost:3001"